import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
  CircularProgress
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;

const VerifyOTPReset = () => {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email || "";

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setError("");
  };

  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value);
    setError("");
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!otp || !newPassword || !confirmPassword) {
      setError("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await axios.post(`${REACT_APP_EXPRESS_SERVER}/reset-password-with-otp`, {
        email,
        otp,
        newPassword
      });

      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate("/signin");
        }, 2000);
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 
        "Failed to reset password. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 8,
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <img 
          src="https://jms.co.ug/wp-content/uploads/2022/06/JMS_logo-1.png" 
          alt="Logo" 
          style={{ width: 100, marginBottom: 16 }} 
        />
        <Typography variant="h6" gutterBottom>
          Reset Password
        </Typography>
        <Typography variant="body2" sx={{ color: "grey" }} gutterBottom>
          Enter the OTP sent to {email} and your new password
        </Typography>

        {error && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
            Password reset successfully! Redirecting to login...
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
          <TextField
            fullWidth
            label="OTP Code"
            variant="outlined"
            margin="normal"
            value={otp}
            onChange={handleOtpChange}
            disabled={isLoading || success}
            inputProps={{ maxLength: 6 }}
          />

          <TextField
            fullWidth
            label="New Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={newPassword}
            onChange={handlePasswordChange}
            disabled={isLoading || success}
          />

          <TextField
            fullWidth
            label="Confirm New Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            disabled={isLoading || success}
            sx={{ mb: 3 }}
          />

          <Button
            fullWidth
            variant="contained"
            sx={{ 
              backgroundColor: "#5C2626", 
              color: "white",
              "&:hover": { backgroundColor: "#4a1e1e" },
              height: "48px",
              mb: 2
            }}
            type="submit"
            disabled={isLoading || success || !otp || !newPassword || !confirmPassword}
          >
            {isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Reset Password"
            )}
          </Button>
          
          <Button
            fullWidth
            variant="outlined"
            sx={{ 
              color: "#5C2626",
              borderColor: "#5C2626",
              "&:hover": { borderColor: "#4a1e1e" },
              height: "48px"
            }}
            onClick={() => navigate(-1)}
            disabled={isLoading}
          >
            Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default VerifyOTPReset;